import { Flex, Heading, Image, Text, Box } from "@chakra-ui/react";
import Carousel from "react-multi-carousel";
import { SectionTitle } from "src/components";

import { Trends } from "src/Constant/radar_trend";

const responsive1 = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 2,
    slidesToSlide: 2,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
    slidesToSlide: 2,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1,
    slidesToSlide: 2,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    slidesToSlide: 2,
  },
};

const LatestHappenings = () => {
  return (
    <Box mt={10}>
      <Box mb={4}>
        <SectionTitle label="Latest happenings..." />
      </Box>
      <Carousel responsive={responsive1}>
        {Trends.map(
          ({ title, reading_time, date_published, label, banner, path }) => (
            <Box
              mr={6}
              height={"550px"}
              border="1px solid #E6E6E6"
              borderRadius={"4px"}
            >
              <Image
                src={banner}
                width={"100%"}
                height={250}
                objectFit={"cover"}
              />
              <Flex
                alignItems={"center"}
                justifyContent={"space-between"}
                my={4}
                px={3}
              >
                <Text fontSize={"12px"} fontWeight={500} color={"#353535"}>
                  {date_published}
                </Text>
                <Text fontSize={"12px"} color={"#353535"} fontWeight={500}>
                  {reading_time}
                </Text>
              </Flex>
              <Box px={3}>
                <Heading
                  as="h4"
                  color={"#0B0A0A"}
                  fontSize={"15px"}
                  fontWeight={600}
                  mb={2}
                >
                  {title}
                </Heading>
                <Text fontSize={"13px"} lineHeight={"1.6em"}>
                  {label}
                </Text>
                <Text
                  variant={"link"}
                  my={4}
                  as="a"
                  target="_blank"
                  href={path}
                  rel="noopener"
                  color={"primary"}
                  fontSize={"14px"}
                  fontWeight={400}
                  display={"flex"}
                  alignItems={"center"}
                  textDecoration={"underline"}
                >
                  Read more
                </Text>
              </Box>
            </Box>
          ),
        )}
      </Carousel>
    </Box>
  );
};

export default LatestHappenings;
